// Routes (un onglet = une page HTML engendrée), adresses, changement d'onglet sans rechargement (pushState).
// --- UNE PAGE PAR ONGLET ---------------------------------------------------------------------------------------
// Le site n'est plus une page unique : chaque onglet est une vraie page (aujourdhui.html, calendrier.html, …,
// engendrées par scripts/pages.py) servie à une adresse propre (/aujourdhui, /calendrier, …). La page HTML pose
// window.PAGE avant de charger ce fichier ; c'est lui qui dit quel onglet dessiner. Changer d'onglet, c'est charger
// l'autre page : le navigateur repart d'un état propre, Précédent/Suivant et les favoris marchent d'eux-mêmes.
window.ROUTES = { accueil: 'accueil', dashboard: 'aujourdhui', catalogue: 'catalogue', calendrier: 'calendrier', qcm: 'qcm', training: 'training', lca: 'lca', stats: 'stats', methode: 'methode', abonnement: 'abonnement', compte: 'compte', gestion: 'gestion' };
window.ONGLET_PAR_ROUTE = (function() { var o = {}; Object.keys(window.ROUTES).forEach(function(k) { o[window.ROUTES[k]] = k; }); return o; })();
// Fichier de chaque page quand l'hébergeur ne réécrit pas les adresses (pas de .htaccess) : on lie alors les .html.
window.ROUTE_FICHIERS = { accueil: 'index.html' };
window.routeSegment = function() { return location.pathname.replace(/\/+$/, '').split('/').pop().replace(/\.html?$/i, ''); };
window.routeOngletCourant = function() {
    if (window.PAGE && window.ONGLET_PAR_ROUTE[window.PAGE]) return window.ONGLET_PAR_ROUTE[window.PAGE];
    var seg = window.routeSegment();
    if (seg === 'index' || seg === '') return 'accueil';
    return window.ONGLET_PAR_ROUTE[seg] || null;
};
// Dossier où vivent les pages. Le site tourne à la racine du domaine, mais rien ne l'y oblige : on retire le dernier
// segment de l'adresse (le nom de page ou de fichier) et on garde le dossier.
window.routeBase = function() {
    if (window.__routeBase != null) return window.__routeBase;
    var p = location.pathname.replace(/[^\/]*$/, '');
    if (p.slice(-1) !== '/') p += '/';
    window.__routeBase = p;
    return p;
};
// Si cette page a été ouverte par son nom de fichier (…/calendrier.html), l'hébergeur ne réécrit sans doute pas
// les adresses : on lie les autres pages par leur fichier aussi, jamais vers une adresse qui pourrait être morte.
window.routeFichiers = function() { return /\.html?$/i.test(location.pathname); };
window.routeUrl = function(tab) {
    var route = window.ROUTES[tab] || window.ROUTES.dashboard;
    if (window.routeFichiers()) return window.routeBase() + (window.ROUTE_FICHIERS[tab] || (route + '.html'));
    return window.routeBase() + (tab === 'accueil' ? '' : route);
};
// Gardé pour les appels existants : l'adresse est déjà la bonne, il n'y a plus rien à réécrire.
window.routeEcrire = function() {};
window.routeInit = function() {
    var vu = window.routeOngletCourant() || 'dashboard';
    // L'accueil n'existe qu'une fois sa page dessinée par window.renderAccueil ; sans lui, c'est le tableau de bord.
    if (vu === 'accueil' && !window.renderAccueil) vu = 'dashboard';
    window.state.activeTab = vu;
};
// Où on en était dans chaque onglet — utile seulement en mode page unique (sans window.PAGE), gardé pour lui.
window.__scrollOnglet = {};
window.reprendreScroll = function(y) {
    if (!y) return;
    var essais = 0;
    (function poser() {
        window.scrollTo(0, y);
        if (Math.abs((window.scrollY || 0) - y) > 2 && ++essais < 60) requestAnimationFrame(poser);
    })();
};
// Titre de l'onglet du navigateur, par onglet du site : le même que celui des pages engendrées par scripts/pages.py.
window.TITRES_ONGLETS = { accueil: 'Accueil', dashboard: "Aujourd'hui", calendrier: 'Calendrier', catalogue: 'Catalogue', qcm: 'QCM', training: 'Training', stats: 'Statistiques', methode: 'Méthode', abonnement: 'Abonnement', compte: 'Mon compte', gestion: 'Gestion' };
window.titreOnglet = function(tab) { return (window.TITRES_ONGLETS[tab] || 'EDN Planner') + ' — EDN Planner'; };
// Changer d'onglet ne recharge PLUS la page. Chaque onglet garde sa vraie adresse (/catalogue, /stats…) — un
// rechargement ou un favori y arrive directement — mais un clic ne fait que changer l'adresse (pushState) et
// redessiner : rien à retélécharger, rien à re-parser, aucun flash « Chargement… ». C'est ce qui rend la navigation
// instantanée, y compris sur téléphone où re-parser 800 Ko de JavaScript coûtait à chaque clic.
window.actions.switchTab = function(tab, sansHistorique) {
    if (window.state.activeTab === tab) return;
    if (window.dictStopIfOn) window.dictStopIfOn(); // micro coupé en changeant d'onglet
    window.__scrollOnglet[window.state.activeTab] = window.scrollY || 0;
    window.state.activeTab = tab;
    // L'adresse reste la vérité : Précédent / Suivant, favoris et rechargement continuent de marcher.
    if (!sansHistorique && window.history && history.pushState) {
        try { history.pushState({ tab: tab }, '', window.routeUrl(tab)); } catch (e) {}
    }
    window.PAGE = window.ROUTES[tab] || window.PAGE;   // ce que lisent les rendus qui regardent « quelle page »
    try { document.title = window.titreOnglet(tab); } catch (e) {}
    var dessiner = function() {
        window.renderHeader();
        window.renderContent();
        var reprise = sansHistorique ? window.__scrollOnglet[tab] : null;
        if (reprise) window.reprendreScroll(reprise);
        else {
            window.scrollTo(0, 0);
            if (tab === 'calendrier') window.calAllerAAujourdhui();
        }
    };
    // Le contenu se fond sous des rails immobiles (view transition) ; sans elle, ou en mouvement réduit, rendu direct.
    var reduit = false; try { reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    if (document.startViewTransition && !reduit && !window.__spaTest) document.startViewTransition(dessiner);
    else dessiner();
};
// Précédent / Suivant : l'adresse a changé, on dessine l'onglet qu'elle désigne, à la position où on l'avait laissé.
window.ongletDepuisAdresse = function() {
    var seg = window.routeSegment();
    if (seg === '' || seg === 'index') return 'accueil';
    return window.ONGLET_PAR_ROUTE[seg] || null;
};
window.addEventListener('popstate', function() {
    var tab = window.ongletDepuisAdresse();
    if (!tab || tab === window.state.activeTab) return;
    if (tab === 'accueil' && !window.renderAccueil) tab = 'dashboard';
    window.actions.switchTab(tab, true);
});

// Adresse d'une page qui n'est pas un onglet (mentions légales, compte…) : même dossier, même règle .html.
window.pageUrl = function(nom) { return window.routeBase() + nom + (window.routeFichiers() ? '.html' : ''); };

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const ROUTES = window.ROUTES;
export const ONGLET_PAR_ROUTE = window.ONGLET_PAR_ROUTE;
export const ROUTE_FICHIERS = window.ROUTE_FICHIERS;
export const routeSegment = window.routeSegment;
export const routeOngletCourant = window.routeOngletCourant;
export const routeBase = window.routeBase;
export const routeFichiers = window.routeFichiers;
export const routeUrl = window.routeUrl;
export const routeEcrire = window.routeEcrire;
export const routeInit = window.routeInit;
export const reprendreScroll = window.reprendreScroll;
export const TITRES_ONGLETS = window.TITRES_ONGLETS;
export const titreOnglet = window.titreOnglet;
export const ongletDepuisAdresse = window.ongletDepuisAdresse;
export const pageUrl = window.pageUrl;
